import { useParams } from 'react-router';
import { usePageNumberFromUrl, usePerPageValueFromUrl } from 'idsk-react-components';
import { useClientFetch } from '../../../context/ClientStatusContext';
import { getPripomienkaFilterList } from '../../../client/pripomienkaFilterClient';
import { ClientStatus } from '../../../model/ClientStatus';
import PripomienkaListPage from '../../../model/pripomienka/PripomienkaListPage';
import ClassType from '../../../model/pripomienka/ClassType';
import useFilterFromUrl from '../../Filter/hook/useFilterFromUrl';
import PripomienkyListFilter from '../../../model/filter/PripomienkyListFilter';
import { defaultPerPageValue, perPageDataArray } from '../../../constants/PaginationPerPageConstants';
import { useSecurityContext } from '../../../context/SecurityContext';

interface ReturnType {
  pripomienkaListPage: PripomienkaListPage;
  pripomienkaStatus: ClientStatus;
  pripomienkaPageNumberFromUrl: number;
  reloadPripomienkyList?() : void;
  filter: PripomienkyListFilter,
}

export default (classType:ClassType): ReturnType => {
  const { page } = usePageNumberFromUrl('page');
  const { perPageValue } = usePerPageValueFromUrl('perPage', perPageDataArray, defaultPerPageValue);
  const { accessToken, organizationId } = useSecurityContext();

  const pripomienkaPageNumberFromUrl = page;
  // @ts-ignore
  const { type, year, index } = useParams<{ type: string, year: number, index: number }>();
  const filter = useFilterFromUrl();
  const {
    data: pripomienkaListPage,
    status: pripomienkaStatus,
    refetch: reloadPripomienkyList,
  } = useClientFetch(
    getPripomienkaFilterList,
    [classType, type, year, index, filter, page, perPageValue, undefined, undefined],
    [page, JSON.stringify(filter), perPageValue, accessToken, organizationId],
  );
  return {
    pripomienkaListPage,
    pripomienkaStatus,
    pripomienkaPageNumberFromUrl,
    reloadPripomienkyList,
    filter,
  };
};
